import React from 'react';
import { createUseStyles } from 'react-jss';
import Notification, { LinkType } from '../../../../../interfaces/Notification';
import moment from 'moment';
import { FiBookmark as TicketIcon } from '@react-icons/all-files/fi/FiBookmark';
import { FiBriefcase as DealIcon } from '@react-icons/all-files/fi/FiBriefcase';
import { FiCalendar as AppointmentIcon } from '@react-icons/all-files/fi/FiCalendar';
import { FiClipboard as TaskIcon } from '@react-icons/all-files/fi/FiClipboard';
import { FiClock as ReminderIcon } from '@react-icons/all-files/fi/FiClock';
import { FiMessageSquare as PostIcon } from '@react-icons/all-files/fi/FiMessageSquare';
import { FiTrello as WallIcon } from '@react-icons/all-files/fi/FiTrello';

interface Props {
  notification: Notification;
  onClick?: () => void;
}

const useStyles = createUseStyles({
  icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 36,
    minWidth: 36,
    borderRadius: '50%',
    backgroundColor: ({ color }) => color,
    marginRight: 10,
  },
  time: {
    color: '#98a6ad',
    fontSize: '.75rem',
  },
  rightContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    color: ({ readed }) => (readed ? '#6c757d' : '#272e37'),
  },
  root: {
    cursor: 'pointer',
    padding: '7px 20px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: ({ readed }) => (readed ? 'white' : '#f8f9fa'),
  },
});

const getAssets = (linkType: LinkType) => {
  switch (linkType) {
    case LinkType.appointment:
      return {
        icon: AppointmentIcon,
        color: '#0acf97',
      };
    case LinkType.deal:
      return {
        icon: DealIcon,
        color: '#39afd1',
      };
    case LinkType.post:
      return {
        icon: PostIcon,
        color: '#727cf5',
      };
    case LinkType.reminder:
      return {
        icon: ReminderIcon,
        color: '#fa5c7c',
      };
    case LinkType.wall:
      return {
        icon: WallIcon,
        color: '#0acf97',
      };
    case LinkType.task:
      return {
        icon: TaskIcon,
        color: '#39afd1',
      };
    case LinkType.ticket:
      return {
        icon: TicketIcon,
        color: '#727cf5',
      };
    default:
      return {
        icon: WallIcon,
        color: '#727cf5',
      };
  }
};

const MenuItem: React.FC<Props> = ({ notification, onClick }) => {
  const { icon: Icon, color } = getAssets(notification.linkType);
  const classes = useStyles({ color, readed: notification.beenSeen });

  const getTimeAgo = (triggerDate: string) => {
    return moment(triggerDate).format('DD-MM-YYYY à HH:mm');
  };

  const ellipsize = (text: string) => {
    if (text.length > 150) {
      return text.substring(0, 150) + '...';
    }
    return text;
  };

  return (
    <div className={classes.root} onClick={onClick}>
      <div className={classes.icon}>
        <Icon size={15} color='white' />
      </div>

      <div className={classes.rightContainer}>
        <div className={classes.title}>{ellipsize(notification.title)}</div>
        <div className={classes.time}>{getTimeAgo(notification.triggerDate)}</div>
      </div>
    </div>
  );
};

export default MenuItem;
